import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redusers/config'

export const useGetThemeMode = () => {
  // const themeMode = localStorage.getItem('themeMode') ? (localStorage.getItem('themeMode') as string) : 'main'
  return useSelector((state: AppState) => state.themeModeReducer.themeMode)
  // return themeMode
}
